import { render, staticRenderFns } from "./Pembelian.vue?vue&type=template&id=dad906e2&"
import script from "./Pembelian.vue?vue&type=script&lang=js&"
export * from "./Pembelian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pembelian.vue"
export default component.exports